import React from 'react';
import { Button } from '@/components/ui/button';
import { Share2 } from 'lucide-react';
import { toast } from '@/components/ui/use-toast';

const APP_STORE_URL = 'https://apps.apple.com/app/id6754500015';
const SHARE_TEXT = "I'm using KidQuotes to save the funny and sweet things my kids say. You should try it!";

interface ShareAppButtonProps {
  variant?: 'default' | 'outline' | 'ghost';
  size?: 'default' | 'sm' | 'lg';
  className?: string;
  fullWidth?: boolean;
}

const ShareAppButton: React.FC<ShareAppButtonProps> = ({
  variant = 'outline',
  size = 'sm',
  className = '',
  fullWidth = false,
}) => {
  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: 'KidQuotes',
          text: SHARE_TEXT,
          url: APP_STORE_URL,
        });
      } catch (error) {
        if (error instanceof Error && error.name !== 'AbortError') {
          fallbackCopy();
        }
      }
    } else {
      fallbackCopy();
    }
  };

  const fallbackCopy = () => {
    navigator.clipboard.writeText(`${SHARE_TEXT} ${APP_STORE_URL}`).then(() => {
      toast({ title: 'Copied!', description: 'Share link copied to clipboard.' });
    });
  };

  return (
    <Button
      variant={variant}
      size={size}
      onClick={handleShare}
      className={`${fullWidth ? 'w-full' : 'w-full sm:w-auto'} ${className}`}
    >
      <Share2 className="h-4 w-4 mr-2" />
      Share KidQuotes
    </Button>
  );
};

export default ShareAppButton;
